/**
 * The answer key of a mate-in-N is a tree of lines, one per accepted key. Pure helpers, kept
 * apart from the form so the eagerly loaded module file never pulls it into the player bundle.
 */
import type { ChessMateDefinition, ChessMateSolution, Line } from "./types";

export function emptySolution(_definition: ChessMateDefinition): ChessMateSolution {
  return { lines: [] };
}

function isLine(value: unknown): value is Line {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const { move, defences } = value as { move?: unknown; defences?: unknown };
  if (typeof move !== "string") return false;
  if (defences === undefined) return true;
  return (
    Array.isArray(defences) &&
    defences.every(
      (d) =>
        typeof d === "object" &&
        d !== null &&
        typeof (d as { move?: unknown }).move === "string" &&
        isLine((d as { line?: unknown }).line),
    )
  );
}

/** Whether a stored value has the solution's shape, whatever the moves say. */
export function isSolution(value: unknown): value is ChessMateSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const lines = (value as { lines?: unknown }).lines;
  return Array.isArray(lines) && lines.every(isLine);
}

/** Reads whatever is stored, however wrong, as a list of lines. */
export function linesOf(value: unknown): Line[] {
  return isSolution(value) ? value.lines.filter((l) => l.move.trim() !== "") : [];
}
